import { ApiCall } from "../apiBase";

/********get all days query********/
export async function getDays() {
  let days = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query getDays {
          getDays {
            id
            day
            isClosed
            openTime
            closeTime
            dayDE
          }
        }
      `,
    },
  });

  if (!result.data.errors && result.data.data.getDays) {
    days = result.data.data.getDays;
  }

  return days;
}

/********get cafe open hours by date query********/
export async function getCafeOpeningHours(date) {
  let openHours = [];

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        query getCafeOpeningHours($date: DateDate!) {
            getCafeOpeningHours(date: $date) {
                startTime
                endTime
            }
        }
      `,
      variables: {
        date: date,
      },
    },
  });

  if (!result.data.errors && result.data.data.getCafeOpeningHours) {
    openHours = result.data.data.getCafeOpeningHours;
  }

  return openHours;
}

/********update a day mutation********/
export async function updateAvaialability(updatedDay) {
  let updateSccuess = false

  const result = await ApiCall({
    method: "post",
    data: {
      query: `
        mutation updateAvaialability($input: CafeInput!) {
            updateAvaialability(input: $input) {
                id
                day
                isClosed
                openTime
                closeTime
                dayDE
          }
        }
      `,
      variables: {
        input: {
          day: updatedDay.day,
          isClosed: updatedDay.isClosed,
          openTime: updatedDay.openTime,
          closeTime: updatedDay.closeTime,
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.updateAvaialability) {
    updateSccuess = true
  }

  return updateSccuess;
}
